export const cubesImage = `
                      
`;
